import type { HawkWidgetAdvancedState } from './model';

export const getSelectedFilter = <T>(
  selectedFilters: HawkWidgetAdvancedState['selectedFilters'],
  activeTab: HawkWidgetAdvancedState['activeTab'],
  property = '',
  defaultValue: T,
): T => selectedFilters[activeTab?.value]?.params[property] ?? defaultValue;
